import request from '@/utils/http';
export const searchLcbsProcessData = (params) => {
    return request({
        url: '/api-sn/lbcs/barcodeFullProcessTracking/searchPage',
        method: 'post',
        data: params
    });
};
export const searchLcbsFileData = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcode/searchPage',
        method: 'post',
        data: params
    });
};
// 档案批量导入
export const uploadFile = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcode/templates/upload',
        method: 'post',
        data: params
    });
};
// 全流程批量导入
export const uploadProcess = (params) => {
    return request({
        url: '/api-sn/lbcs/barcodeFullProcessTracking/templates/upload',
        method: 'post',
        data: params
    });
};
// 海外全流程批量导入
export const importProcess = (params) => {
    return request({
        url: '/api-sn/lbcs/barcodeSwapOverseas/import',
        method: 'post',
        data: params
    });
};
export const searchBarcodeSwapOverseas = (params) => {
    return request({
        url: '/api-sn/lbcs/barcodeSwapOverseas/search',
        method: 'post',
        data: params
    });
};
// 扫码率监控
export const scanRateMonitorByPage = (params) => {
    return request({
        url: '/api-sn/lbcs/scanRateMonitor/scanRateMonitorByPage',
        method: 'post',
        data: params
    });
};
// 条码解析查询
export const searchBatchData = (params) => {
    return request({
        url: '/api-sn/lbcs/bcDecodeBatch/searchBatchData',
        method: 'post',
        data: params
    });
};
// 解析结果列表-条码
export const searchPage = (params) => {
    return request({
        url: '/api-sn/lbcs/bcDecodeBatch/searchPage',
        method: 'post',
        data: params
    });
};
// 解析结果列表-产品
export const searchItemPage = (params) => {
    return request({
        url: '/api-sn/lbcs/bcDecodeBatch/searchItemPage',
        method: 'post',
        data: params
    });
};
// 条码盘点导入
export const bcBarcodeupload = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcodeCheck/upload',
        method: 'post',
        data: params
    });
};

// TVPC SELL IN导入
export const sellInUpload = (params) => {
    return request({
        url: '/api-sn/sellIn/upload',
        method: 'post',
        data: params,
        responseType: 'arraybuffer'
    });
};

// TVPC SELL IN批量查询导出
export const searchExport = (params) => {
    return request({
        url: '/api-sn/sellIn/uploadSearch',
        method: 'post',
        data: params
    });
};

// 条码盘点导入列表
export const bcBarcodelist = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcodeCheck/page',
        method: 'post',
        data: params
    });
};
// 条码盘点
export const bcBarcodeCheck = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcodeCheckDtl/bcBarcodeCheck',
        method: 'post',
        data: params
    });
};
// 条码盘点导入所有查询列表
export const allChecklist = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcodeCheckDtls/listByPage',
        method: 'post',
        data: params
    });
};
// 条码盘点导入所有批量删除
export const allCheckdelete = (params) => {
    return request({
        url: '/api-sn/lbcs/bcBarcodeCheckDtls/batchDelete',
        method: 'post',
        data: params
    });
};

// 扫码率监控-明细查询
export const scanRateMonitorDetail = (params) => {
    return request({
        url: '/api-sn/lbcs/scanRateMonitor/scanRateMonitorDetail',
        method: 'post',
        data: params
    });
};

// 大小箱对应关系查询
export const boxRelation = (params) => {
    return request({
        url: '/api-sn/bcBarcodeMatchs/getBarcodeNo',
        method: 'post',
        data: params
    });
};

// 条码盘点导入 文件信息查询
export const barCodeFileInfoQuery = (params) => {
    return request({
        url: '/api-sn/config/uploadRecord/searchByPage',
        method: 'post',
        data: params
    });
};

// TVPC SELL IN界面查询
export const sellInSearch = (params) => {
    return request({
        url: '/api-sn/sellIn/search',
        method: 'post',
        data: params
    });
};

//  历史条码流向跟踪
export const historyBarcodeQuery = (params) => {
    return request({
        url: '/api-sn/lbcs/barcodeFullProcessTracking/searchOldSwap',
        method: 'post',
        data: params
    });
};

//  条码流向产品信息
export const getProductInfo = (params) => {
    return request({
        url: '/api-sn/scene/applet/getProductInfo',
        method: 'get',
        params: params
    });
};
//  条码流向生产信息
export const getProduceInfo = (params) => {
    return request({
        url: '/api-sn/scene/applet/getProduceInfo',
        method: 'get',
        params: params
    });
};
//  条码流向品质信息
export const getQualityInfo = (params) => {
    return request({
        url: '/api-sn/scene/applet/getQualityInfo',
        method: 'get',
        params: params
    });
};
//  条码流向品质信息
export const barcodeFullProcessTracking = (params) => {
    return request({
        url: '/api-sn/scene/applet/barcodeFullProcessTracking',
        method: 'get',
        params: params
    });
};
//  条码流向工厂制造
export const manufactSearch = (params) => {
    return request({
        url: '/api-sn/index/scene/factory/manufact/search',
        method: 'get',
        params: params
    });
};

//  四码合一列表查询
export const fourYardsInOne = (params) => {
    return request({
        url: '/api-sn/lbcs/fourYardsInOne/list',
        method: 'post',
        data: params
    });
};
//  四码合一列表详情查询
export const fourYardsInOneDetail = (params) => {
    return request({
        url: '/api-sn/lbcs/fourYardsInOne/detail',
        method: 'get',
        params: params
    });
};

// 档案表查询接口
export const barcodeTobSearch = (params) => {
    return request({
        url: '/api-sn/barcode/barcodeTob/page',
        method: 'post',
        data: params
    });
};

//  条码中间表查询
export const executeStatus = (params) => {
    return request({
        url: '/api-sn/barcode/batchOiTob/page',
        method: 'post',
        data: params
    });
};
// 档案表查询接口
export const wholeProcessTrackingSearch = (params) => {
    return request({
        url: '/api-sn/barcode/swap/wholeProcess',
        method: 'post',
        data: params
    });
};

//  条码中间表明细查询
export const executeStatusDetail = (params) => {
    return request({
        url: '/api-sn/barcode/recordOiTob/page',
        method: 'post',
        data: params
    });
};

//  条码中间表明细查询
export const uploadRecordSearchByPage = (params) => {
    return request({
        url: '/api-sn/config/uploadRecord/searchByPage',
        method: 'post',
        data: params
    });
};